<atx-searchable-contacts-list
  [contacts$]="contacts$"
  [isSalesRep]="isSalesRep$ | async"
  [activeAccount$]="activeAccount$"
>
  <ng-template #contactsList let-contacts>
    <epc-contact-list
      [contacts]="contacts"
      (call)="callContact($event)"
      [userCalling]="userCalling$ | async"
    >
    </epc-contact-list>
  </ng-template>
</atx-searchable-contacts-list>
